<template style="background-color: #e9e9e9;">
  <div class="home">
    <div>
      <div class="" style="text-align: center">
        <img
            alt="logo"
            src="../assets/logo_quick_pay_2022.png"
        />
      </div>
<!--      <h1>Términos y Condiciones</h1>-->
      <div class="body">
        <h3>Política de Privacidad</h3>
        <p>
          Somos EA Solution S.A.C., con RUC 20607787027, con domicilio en Av. Del Ejército Nº
          244, Dpto. 1403, Magdalena del Mar, Lima, Perú y estamos sujetos a la legislación
          peruana. Le brindamos acceso a nuestro sitio web y a la aplicación móvil que le permite
          comprar productos de ciertos minoristas/retailers con los que tenemos relaciones
          contractuales. Usando nuestro aplicativo evita realizar el check-out o las colas de espera
          en dichos establecimientos y gozar de servicios relacionados, de acuerdo con nuestros
          Términos de Uso. Al usar nuestras plataformas, nos confías tus datos personales y
          nosotros nos comprometemos a ser responsables y mantener esa confianza. Por ello,
          queremos que conozcas más sobre nuestras prácticas de privacidad. Cabe precisar, que
          estaremos a cargo de los datos proporcionados en conjunto con:
        </p>
        <ul>
          <li>
            KUSHKI PERU SRL, con RUC: 20603543581, con domicilio en Av. República de
            Panamá 3420, Dpto. 1701, Urb. Limatambo, San isidro, Lima, Perú. También
            conocida como Kushki, quienes están a cargo del procesamiento de los pagos de
            los usuarios.
          </li>
        </ul>

        <p>Esta empresa será la que controle la información de pagos cuando
          compre productos a través de nuestros servicios. Queremos que tomes en cuenta
          sus políticas de privacidad
          <a href="https://kushkipagos.com/en/legal/politica-de-privacidad-peru" target="_blank">https://kushkipagos.com/en/legal/politica-de-privacidad-peru</a>.</p>

        <!-- Sección "¿Qué información necesitamos y por qué?" -->
        <h3>¿Qué información necesitamos y por qué?</h3>
        <p>
          Necesitamos su nombre, fecha de nacimiento, sexo y datos de contacto para recopilar
          su información de ubicación, con el fin de proporcionar los servicios. También
          recopilamos información relacionada con usted y su comportamiento en línea de
          manera menos directa:
        </p>
        <ul>
          <li>Rastrearlo en línea y en todos los dispositivos, incluido el uso de cookies:
            utilizamos esto para comercializar nuestros productos y servicios (y el de los
            minoristas) donde tenemos el consentimiento adecuado para hacerlo y para evitar
            el uso de nuestra aplicación o sitio web para transacciones fraudulentas.</li>
          <li>Combinando los datos que proporciona con otros datos, en particular, los datos
            de productos y transacciones de los sistemas de minoristas, lo utilizamos para
            crear un perfil de cliente preciso basado en los intereses y el comportamiento
            de la plataforma.</li>
          <li>Utilizamos algoritmos, que analizan los datos sobre usted en las redes sociales,
            los datos de ubicación y el acceso a los sitios web de los minoristas; los  utilizamos
            para crear perfiles relacionados con sus hábitos de compra y, cuando tengamos
            los consentimientos adecuados de su parte, para ofrecerle productos y servicios
            en los que podría estar interesado. También podemos anonimizar sus datos y
            agregarlos a los datos de otros usuarios (para que no pueda ser identificado a
            partir de esta información y ya no sean datos personales relacionados con usted)
            y proporcionar servicios de análisis de datos a ciertos distribuidores con los que
            tenemos relaciones contractuales.</li>
        </ul>


        <p>
          Estamos procesando su información:
        </p>
        <ul>
          <li>Para prestar los servicios.</li>
          <li>Ya que es necesario para nuestro cumplimiento de los Términos.</li>
          <li>Ya que esto es necesario en la búsqueda de nuestros intereses legítimos en
            ofrecer, desarrollar y comercializar los servicios. Hemos equilibrado nuestros
            intereses legítimos con cualquier riesgo potencial para sus derechos de
            protección de datos, pues estos se ven superados por los beneficios significativos
            de poder brindarle los servicios a usted y a otros usuarios, mejorar los tiempos
            de pago cuando usted y otros compran a minoristas y mejorar nuestros servicios.
          </li>
        </ul>

        <!-- Sección "¿Con quién compartimos su información?" -->
        <h3>¿Con quién compartimos su información?</h3>
        <p>
          Podemos compartir su información personal con:
        </p>
        <ul>
          <li>Distribuidores para realizar sus transacciones y realizar nuestros servicios.</li>
          <li>Nuestros proveedores de servicios e infraestructura de TI, quienes dan soporte
            a nuestra aplicación, sitio web y soluciones de almacenamiento de TI. Licencias
            que pertenecen a todos los proveedores de software e infraestructura de
            terceros.
          </li>
          <li>KUSHKI PERU SRL(con el RUC: 20603543581), con domicilio enn Av. República de Panamá
            3420, Dpto. 1701, Urb. Limatambo, San isidro, Lima, Perú. También conocida como KUSHKI,
            con el propósito de procesar su pago.
          </li>
          <li>Cualquier otro tercero, según lo exija la ley, para prevenir o investigar violaciones
            de nuestros Términos, para hacer cumplir o investigar las vulnerabilidades de
            seguridad o para responder a emergencias y para proteger los derechos de
            terceros.
          </li>
          <li>Cualquier compañía o grupo empresarial que pueda fusionarse o adquirirnos. Si
            tuviéramos que reorganizar o reestructurar nuestro negocio, es posible que sus
            datos se consideren un activo vendible y se puedan vender o transferir a
            terceros.
          </li>
        </ul>

        <!-- Sección "¿Cuánto tiempo lo mantendremos?" -->
        <h3>¿Cuánto tiempo lo mantendremos?</h3>
        <p>
          Mantenemos su información personal durante el período requerido para realizar los
          servicios y luego durante 12 meses después de que termine su relación con nosotros
          mediante la eliminación de su perfil de nuestra aplicación o sitio web. En otros casos, su
          información será despersonalizada, por lo que no se le podría atribuir individualmente
          ninguna característica y estos datos son usados para el análisis de datos y propósitos de
          desarrollo de productos. De lo contrario, borraremos de forma segura su información
          cuando ya no sea necesaria.
        </p>


        <!-- Sección "Usted tiene los siguientes derechos con respecto a su información" -->
        <h3>Usted tiene los siguientes derechos con respecto a su información</h3>
        <ul>
          <!-- Derecho a ser informado -->
          <li>
            <p><strong>El derecho a ser informado:</strong></p>
            <p>
              Tiene derecho a que se le proporcione información clara, transparente y fácilmente comprensible
              sobre cómo utilizamos su información y sus derechos. Por este motivo le proporcionamos la
              información contenida en esta Política de privacidad.
            </p>
          </li>

          <!-- Derecho de acceso -->
          <li>
            <p><strong>El derecho de acceso:</strong></p>
            <p>
              Tiene derecho a obtener acceso a su información (si la estamos procesando) y otra información
              cierta (similar a la que se proporciona en esta Política de privacidad). Esto es para que esté
              al tanto y pueda verificar que estamos usando su información de acuerdo con la Ley de
              Protección de Datos Personales.
            </p>
          </li>

          <!-- Derecho a restringir el procesamiento -->
          <li>
            <p><strong>El derecho a restringir el procesamiento:</strong></p>
            <p>
              Tiene derechos para 'bloquear' o suprimir el uso posterior de su información. Cuando el
              procesamiento está restringido, aún podemos almacenar su información, pero no podemos usarla
              más. Mantenemos listas de personas que han solicitado un uso adicional de su información para
              que sean 'bloqueadas' para asegurarnos de que se respete la restricción en el futuro.
            </p>
          </li>

          <!-- Derecho a la portabilidad de datos -->
          <li>
            <p><strong>El derecho a la portabilidad de datos:</strong></p>
            <p>
              Tiene derecho a obtener y reutilizar sus datos personales para sus propios fines en diferentes
              servicios. Por ejemplo, si decide cambiar a un nuevo proveedor, esto le permite mover, copiar o
              transferir su información fácilmente entre nuestros sistemas de TI y los suyos de manera
              segura, sin afectar su facilidad de uso.
            </p>
          </li>

          <!-- Derecho a objetar -->
          <li>
            <p><strong>El derecho a objetar:</strong></p>
            <p>
              Usted tiene el derecho de objetar ciertos tipos de procesamientos, incluido el procesamiento
              para marketing directo (lo que hacemos solo con su consentimiento).
            </p>
          </li>

          <!-- Derechos en relación con la toma de decisiones automatizada y el perfilado -->
          <li>
            <p><strong>Derechos en relación con la toma de decisiones automatizada y el perfilado:</strong></p>
            <p>
              Utilizamos la tecnología para crear perfiles sobre usted y podemos aprobar o denegar
              automáticamente solicitudes basadas en factores predeterminados relacionados con su capacidad
              para cumplir con sus compromisos financieros en el caso de que utilice un método de pago que
              nos obligue a hacerlo, y para usted significa que podemos hacer ciertas suposiciones sobre
              productos en los que podría estar interesado y usar esto para enviarle comunicaciones de
              marketing más personalizadas. El perfil sobre usted también contendrá información sobre su
              compra en las tiendas y su conducta al momento de la compra, en cuyo caso, si el vendedor lo
              considera un comprador arriesgado en relación con el robo, es posible que debamos desactivar
              su perfil y restringir su uso del servicio. Por lo general, actuaremos en las solicitudes y
              proporcionaremos información de forma gratuita.
            </p>
          </li>

          <!-- Solicitudes infundadas o excesivas/repetidas -->
          <li>
            <p><strong>Solicitudes infundadas o excesivas/repetidas.</strong></p>

          </li>
          <li>
            <p><strong>Más copias de la misma información.</strong></p>
            <p>
              Alternativamente, podemos tener derecho a negarnos a actuar en la solicitud.
              Por favor, considere su solicitud con responsabilidad antes de enviarla.
              Responderemos tan pronto como podamos. Generalmente, esto será dentro de
              un mes desde el momento en que recibimos su solicitud, pero si la solicitud
              demorase más que eso, se lo comunicaremos.
            </p>
          </li>

          <p>
            Si no está satisfecho con la forma en que manejamos su información o si desea
            ejercer sus derechos, contáctenos aquí:
            Av. Del Ejército 244, Dpto. 1403, Magdalena del Mar, Lima, Perú o al
            correo <a href="mailto:info@quickpay.com.pe">info@quickpay.com.pe</a>.
            Si no está satisfecho con nuestra respuesta a su queja o cree que nuestro
            procesamiento de su información no cumple con la ley de protección de datos,
            puede presentar una queja ante la autoridad de protección de datos del
            consumidor del Perú.
          </p>
          <p>
            Si no está satisfecho con nuestra respuesta a su queja o cree que nuestro
            procesamiento de su información no cumple con la ley de protección de datos,
            puede presentar una queja ante la autoridad de protección de datos del
            consumidor del Perú.
          </p>
        </ul>





      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}

</script>
<style scoped>
  h3 {
    font-weight: bold;
    font-size: 17px;
  }
  h4{
    font-size: 21px;
    font-weight: bold;
  }
  h1{
    text-align: center;
    padding-bottom: 2%;
    font-weight: bold
  }
  p{
    text-align: justify;
  }
  .home{
    padding: 0 5% 0 5% ;
    max-width: 1366px;
    margin: 0 auto;
  }
  img{
    width: 20%
  }

  @media only screen and (max-width: 600px) {
    img {
      width: 50%
    }
    h1{
      font-size: 30px;
    }
    h3{
      font-size: 25px;
    }
  }

</style>
